import React from "react";
import styled from "styled-components";
// Assets
import QuoteIcon from "../../assets/svg/Quotes";

export default function TestimonialBox({ text, author, company, url }) {
  return (
    <Wrapper className="darkBg radius8 flexNullCenter flexColumn">
      <QuoteWrapper>
        <QuoteIcon />
      </QuoteWrapper>
        <div style={{display:'flex',height:'70%', alignItems:'center' }}>
      <p  className="whiteColor font13" style={{ paddingBottom: "30px" }}>
        {text}
      </p>
      </div>
      <div style={{display:'flex',height:'30%', alignItems:'center' }}>
 <p className="orangeColor font13" style={{alignSelf: 'flex-end', textAlign: 'right'}}>
        <strong>{author}</strong> | 
        <CompanyLink 
          href={url} 
          target="_blank" 
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          {company}
        </CompanyLink>
      </p>
      </div>
     
    </Wrapper>
  );
}

const CompanyLink = styled.a`
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  margin-left: 4px;
  
  &:hover {
    text-decoration: underline;
    opacity: 0.8;
  }
`;

const AuthorSection = styled.div`
  align-self: flex-end;
  text-align: right;
`;

// export default function TestimonialBox({ text, author,company }) {
//   return (
//     <Wrapper className="darkBg radius8 flexNullCenter flexColumn">
//       <QuoteWrapper>
//         <QuoteIcon />
//       </QuoteWrapper>
//       <p className="whiteColor font13" style={{ paddingBottom: "30px" }}>
//         {text}
//       </p>
//       <p className="orangeColor font13" style={{alignSelf: 'flex-end'}}>
//         <em>{author}</em>
//       </p>

//        <p className="orangeColor font13" style={{alignSelf: 'flex-end'}}>
//         <em>{company}</em>
//       </p>
       
//     </Wrapper>
//   );
// }

const Wrapper = styled.div`
  width: 100%;
  padding: 10px 30px;
  height:100px;
  margin-top: 30px;
  min-height: 200px; 
`;
const QuoteWrapper = styled.div`
  position: relative;
  top: -40px;
`;